import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const OrderSummary = ({ selectedShippingRate }) => {
  const cartreduxdata = useSelector((state) => state.cart);
  const packagesreduxdata = useSelector((state) => state.packages);
  const personalisedreduxdata = useSelector((state) => state.personalised);
  const servicedata = useSelector((state) => state.services);

  const [easypostShipping, setEasypostShipping] = useState(null);

  console.log("servicedata8888", servicedata);

  // Load shipping data from localStorage (for page refresh)
  useEffect(() => {
    // ✅ If selectedShippingRate is explicitly null, clear easypostShipping
    if (selectedShippingRate === null) {
      setEasypostShipping(null);
      return;
    }

    const storedShipping = localStorage.getItem("selectedShipping");
    if (storedShipping) {
      try {
        const shippingData = JSON.parse(storedShipping);
        setEasypostShipping(shippingData);
        console.log("Loaded selected shipping:", shippingData);
      } catch (e) {
        console.error("Error parsing shipping data:", e);
      }
    }
  }, [servicedata, selectedShippingRate]);

  // Calculate order total
  var orderTotal = 0;
  cartreduxdata?.forEach((item) => {
    orderTotal += parseFloat(item.cartamount);
  });

  // Calculate packages total
  var packtotal = 0;
  packagesreduxdata.forEach((item) => {
    if (item && item.cartamount) {
      packtotal += parseFloat(item.cartamount);
    }
  });

  // Calculate personalised total
  personalisedreduxdata.forEach((item) => {
    if (item && item.cartamount) {
      packtotal += parseFloat(item.cartamount);
    }
  });

  // ✅ Determine delivery charge - Priority order:
  // 1. If selectedShippingRate is explicitly null (collection mode), show 0
  // 2. selectedShippingRate prop (real-time selection)
  // 3. easypostShipping from localStorage (after page refresh)
  // 4. servicedata from Redux (fallback)
  let deliveryCharge = 0;
  let deliveryChargeName = "Shipping";
  let showShippingDetails = false;

  // ✅ If selectedShippingRate is explicitly passed as null, don't show shipping
  if (selectedShippingRate === null) {
    deliveryCharge = 0;
    showShippingDetails = false;
  } else if (selectedShippingRate && selectedShippingRate.rate) {
    // User just selected a rate
    deliveryCharge = parseFloat(selectedShippingRate.rate);
    deliveryChargeName = `${selectedShippingRate.carrier} - ${selectedShippingRate.service}`;

    if (selectedShippingRate.delivery_days) {
      const days = selectedShippingRate.delivery_days;
      deliveryChargeName += ` (${days}${
        typeof days === "number" ? " days" : ""
      })`;
    }
    showShippingDetails = true;
  } else if (easypostShipping && easypostShipping.rate) {
    // Loaded from localStorage after refresh
    deliveryCharge = parseFloat(easypostShipping.rate);
    deliveryChargeName = `${easypostShipping.carrier} - ${easypostShipping.service}`;

    if (easypostShipping.delivery_days) {
      const days = easypostShipping.delivery_days;
      deliveryChargeName += ` (${days}${
        typeof days === "number" ? " days" : ""
      })`;
    }
    showShippingDetails = true;
  } else if (servicedata && servicedata.rate) {
    // Fallback to Redux servicedata
    deliveryCharge = parseFloat(servicedata.rate);
    deliveryChargeName = servicedata.carrier
      ? `${servicedata.carrier} - ${servicedata.service}`
      : "Shipping";

    if (servicedata.delivery_days) {
      const days = servicedata.delivery_days;
      deliveryChargeName += ` (${days}${
        typeof days === "number" ? " days" : ""
      })`;
    }
    showShippingDetails = true;
  }

  console.log("Delivery charge:", deliveryCharge);
  console.log("Delivery name:", deliveryChargeName);

  // Calculate grand total
  const grandTotal = orderTotal + packtotal + deliveryCharge;

  return (
    <div>
      <div className="checkout_detail_box">
        <h3>Order Summary</h3>
        <div className="p-0 mt-3 mb-4">
          <table className="checkout_tbl2">
            <tbody>
              {/* Cart Items */}
              {cartreduxdata && cartreduxdata.length > 0 ? (
                cartreduxdata.map((item, index) => (
                  <tr key={item.productid || index}>
                    <td>
                      <b>
                        {item.name} (qty: {item.cartquantity})
                      </b>
                    </td>
                    <td>
                      <b>
                        <i className="fas fa-pound-sign"></i>
                        {parseFloat(item.cartamount).toFixed(2)}
                      </b>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2}>No items in cart</td>
                </tr>
              )}

              {/* Packages/Personalised Total (if any) */}
              {packtotal > 0 && (
                <tr>
                  <td>
                    <b>Additional Items</b>
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#666",
                        fontWeight: "normal",
                      }}
                    >
                      Packages & personalisation
                    </div>
                  </td>
                  <td>
                    <b>
                      <i className="fas fa-pound-sign"></i>
                      {packtotal.toFixed(2)}
                    </b>
                  </td>
                </tr>
              )}

              {/* Shipping Charge */}
              {showShippingDetails && deliveryCharge > 0 ? (
                <tr>
                  <td>
                    <b>
                      {selectedShippingRate?.service
                        ?.replace(
                          "ParcelShop Drop-Off Next Day",
                          "Standard 2-4 Day"
                        )
                        .replace("ParcelShop Drop-Off", "Standard 2-4 Day")
                        .replace("Next Day", "Next Working Day")
                        .replace("Next day", "Next Working Day") ||
                        easypostShipping?.service
                          ?.replace(
                            "ParcelShop Drop-Off Next Day",
                            "Standard 2-4 Day"
                          )
                          .replace("ParcelShop Drop-Off", "Standard 2-4 Day")
                          .replace("Next Day", "Next Working Day")
                          .replace("Next day", "Next Working Day") ||
                        "Shipping"}
                    </b>
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#999",
                        fontWeight: "normal",
                      }}
                    >
                      Real-time shipping rate
                    </div>
                  </td>
                  <td>
                    <b>
                      <i className="fas fa-pound-sign"></i>
                      {deliveryCharge.toFixed(2)}
                    </b>
                  </td>
                </tr>
              ) : (
                <tr style={{ backgroundColor: "#fff9e6" }}>
                  <td
                    colSpan={2}
                    style={{ textAlign: "center", padding: "10px" }}
                  >
                    <i
                      className="fas fa-info-circle"
                      style={{ marginRight: "5px", color: "#856404" }}
                    ></i>
                    <span style={{ fontSize: "12px", color: "#856404" }}>
                      Shipping cost will be added after selection
                    </span>
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <b>Total Amount To Pay</b>
                </td>
                <td>
                  <b>
                    <i className="fas fa-pound-sign"></i>
                    {grandTotal.toFixed(2)}
                  </b>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
